import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BasePageComponent } from '../../../base-page';
import { Account } from '../../../../model/account.model';
import { FormValidator } from '../../../../model/champs_formulaire/form-validator.model';
import { Observable, Subject } from 'rxjs';
import { IServiceItem } from '../../../../model/service-item.model';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseService } from '../../base/base.service';
import { ServiceItemService } from '../../service-items/service-item.service';
import { FormService } from '../../../../shared/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { ValidatorAffectedService } from '../validator_affected/validator-affected.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { TranslateService } from '@ngx-translate/core';
import { ConstantValidatorsAffected } from '../validator_affected/validator-affected.url';
import { ConstantHome } from '../../home/home.url';
import { Url } from '../../../../shared/constant/url.constant';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { ValidatorAffectedUpdateComponent } from '../validator_affected/update/validator-affected-update.component';
import { ValidatorAffectedDeleteComponent } from '../validator_affected/delete/validator-affected-delete.component';
import { SourceFormModel } from '../../../../model/champs_formulaire/source-form.model';
import { SourceFormService } from './source-form.service';
import { ConstantSourceForm } from './source-form.url';
import { SourceFormUpdateComponent } from './update/source-form-update.component';
import { SourceFormDeleteComponent } from './delete/source-form-delete.component';

@Component({
  selector: 'app-source-form',
  templateUrl: './source-form.component.html'
})
export class SourceFormComponent extends BasePageComponent implements OnInit,
  OnDestroy {

  @ViewChild('basicTable') tabRef: any;
  account: Account; // the account connected.
  countriesList: SourceFormModel[];
  countriesSearch: SourceFormModel[];
  searchValue: string;

  serviceItemTyped = '';

  subs$ = new Subject<void>();

  serviceItemsList: IServiceItem[] = [];
  serviceItemSelected: IServiceItem;
  myControl = new UntypedFormControl();
  filteredOptions: Observable<IServiceItem[]>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public baseService: BaseService,
    private serviceItemService: ServiceItemService,
    private cdRef: ChangeDetectorRef,
    private formService: FormService,
    private dialog: MatDialog,
    private sourceFormService: SourceFormService,
    private accountService: AccountService,
    store: Store<IAppState>, httpSv: HttpService,
    private translate: TranslateService) {
    super(store, httpSv);
    console.log('## construct SourceForm list');
    this.pageData = {
      title: ConstantSourceForm.data.sub.list.title,
      key: 'sourceForm.title',
      // fil d'ariane.
      breadcrumbs: [
        {
          title: ConstantHome.data.title,
          key: 'home',
          route: Url.SLASH_ROUTE.concat(ConstantHome.data.routing)
        },
        {
          title: ConstantSourceForm.data.title,
          key: 'sourceForm.name',
          route: Url.SLASH_ROUTE.concat(ConstantSourceForm.urlFull
            .FEES.LIST)
        },
        {
          title: ConstantSourceForm.data.sub.lister,
          key: 'lister'
        }
      ]
    };
    if (this.pageData.key === 'sourceForm.title') {
      translate.get('sourceForm.title').subscribe(res => this.pageData.title = res);
    }

    this.pageData.breadcrumbs.forEach(value => {
      if (value.key === 'home') {
        translate.get('home').subscribe(res => value.title = res);
      }
      if (value.key === 'sourceForm.name') {
        translate.get('sourceForm.name').subscribe(res => {
          console.log('## res: ', res);
          value.title = res;
        });
      }
      if (value.key === 'lister') {
        translate.get('lister').subscribe(res => value.title = res);
      }
    });
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    console.log('## init SourceForm list');
    super.ngOnInit();
    this.accountService.identity(false).pipe(takeUntil(this.subs$))
      .subscribe(account => {
        try {
          this.activatedRoute.queryParams.subscribe(
            (params: Params) => {
              const n = Object.keys(params).length;
              console.log('## params lg: ', params);
              console.log('## params n: ', n);
              this.account = account;
              if(n > 0) {
                const formId = params['champs_formulaire'];
                console.log('## val form: ', formId);
                if (formId) {
                  console.log('## get all formValidator by formulaire id');
                  let params = new HttpParams();
                  params = params.set('champsFormulaireId', formId);
                  this.sourceFormService.query(this.sourceFormService.resourceUrl,
                    params)
                    .subscribe(res => {
                      this.getTheData(res);
                    });
                //  this.getServiceItemList(); // after 500ms.
                } else {
                  super.setLoaded();
                }
              } else {
                console.log('## get all SourceForm');
                this.sourceFormService.query(this.sourceFormService.list_url)
                  .subscribe(res => {
                    console.log('## Success get SourceForm list: ', res);
                    this.getTheData(res);
                  }, error => {
                    console.log('## error get sourceform list: ', error);
                    super.setLoaded();
                  });
              //  this.getServiceItemList(); // after 500ms.
              }
            });
          this.getDataAsync();
        } catch (e) {
          console.log('## error identity:', e.message);
        }
      });
  }

  ngOnDestroy() {
    console.log('## on destroy validator list');
    this.formService.free(this.subs$);
    super.ngOnDestroy();
  }

  displayFn(subject: IServiceItem) {
    return subject ? subject.name : '';
  }

  getServiceItemList() {
    setTimeout(() => {
      this.serviceItemService
        .query()
        .pipe(
          filter((mayBeOk: HttpResponse<IServiceItem[]>) => mayBeOk.ok),
          map((response: HttpResponse<IServiceItem[]>) => response.body)
        )
        .subscribe((res: IServiceItem[]) => {
            console.log('## success get list service item: ', res);
            const rs = res ? res : [];
            console.log('## size: ' + rs.length);
            this.serviceItemsList = rs;
            this.filteredOptions = this.myControl.valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value))
              );
          },
          (res: HttpErrorResponse) => {
            console.log('## error get list service item: ' + res.message);
          });
    }, 500);
  }

  private _filter(value: string): IServiceItem[] {
    let filteredList;
    try {
      const filterValue = value.toLowerCase();
      filteredList = this.serviceItemsList.filter(option => option.name.toLowerCase()
        .includes(filterValue));
    } catch (e) {
      console.log('## error filter service item: ' + e.message);
    }
    return filteredList;
  }

  changeItem(event) {
    try {
      console.log('## select item');
      const si = event.option.value;
      console.log('## value item: ' + si.name);
      this.serviceItemSelected = si;
      this.searchServiceItem();
      this.router.navigate(['/' + ConstantSourceForm.urlFull.FEES.LIST],
        { queryParams: { service: si.name } });
    } catch (e) {
      console.log('## error selected value s item');
    }
  }

  searchServiceItem(): void {
    const query = this.serviceItemSelected.name;
    const result = this.countriesSearch.filter(obj => {
      return obj.serviceItemName === query;
    });
    this.countriesList = [];
    result.forEach((c) => {
      this.countriesList.push(c);
    });
  }

  updateData(data: SourceFormModel[]) {
    data.forEach(d => {
      try {
        d.serviceItemName = d.champsFormulaire.serviceItem.name;
        d.labelFormulaire = d.champsFormulaire.label;
      } catch (e) {
        console.log('## erreur: ', e);
      }
    });
  }

  getDataAsync() {
    this.sourceFormService.getObjetObs().pipe(takeUntil(this.subs$))
      .subscribe((res: SourceFormModel[]) => {
        console.log('## get list country in list by subject: ', res);
        this.countriesList = (res) ? res : [];
        this.countriesSearch = this.countriesList;
      });
  }

  getTheData(res: HttpResponse<SourceFormModel[]>) {
    this.countriesList = (res.body) ? res.body : [];
   // this.updateData(this.countriesList);
    this.countriesSearch = this.countriesList;
    super.setLoaded();
  }

  search(): void {
    const query = this.searchValue;
    console.log('## search: ' + query);
    const mapFn = (item) =>
      Object.values(item)
        .map(function(val) {
          return val?.toString().toLowerCase();
        })
        .join(' ');
    const stringArr = [...this.countriesSearch].map(mapFn);
    const result = this.countriesSearch.filter(
      (_, i) => stringArr[i].indexOf(query && query.length ? query.toLowerCase() : '') > -1
    );
    this.countriesList = [];
    result.forEach((c) => {
      this.countriesList.push(c);
    });
  }

  update(c: SourceFormModel) {
    console.log('## data c: ', c);

    this.sourceFormService.setObjetSelectObs(c);
    this.baseService.open(this.dialog, SourceFormUpdateComponent);
  }

  delete(c: SourceFormModel) {
    this.sourceFormService.setObjetSelectObs(c);
    this.baseService.open(this.dialog, SourceFormDeleteComponent);
  }

/*  liste(c: FormValidator) {
    this.sourceFormService.setObjetSelectObs(c);
    this.baseService.open(this.dialog, ValidatorAffectedUpdateComponent);
  }

  delete(c: FormValidator) {
    this.sourceFormService.setObjetSelectObs(c);
    this.baseService.open(this.dialog, ValidatorAffectedDeleteComponent);
  }*/

  /**
   * Retourne la liste des des country
   * qui ont été stockés dans le selector 'nz-table'.
   */
  getList(): SourceFormModel[] {
    return (this.tabRef) ? this.tabRef.data : [];
  }
}